import { render, staticRenderFns } from "./PlanoFilial.vue?vue&type=template&id=37024568"
import script from "./PlanoFilial.vue?vue&type=script&lang=js"
export * from "./PlanoFilial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports